import React from "react";

const DriverIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M10.0403 0.32666C13.8739 -0.707658 16.3538 0.960796 17.1145 1.92432C16.7342 1.82289 15.4101 2.8371 13.1584 7.70557C10.3439 13.7912 11.7137 15.9972 12.1702 15.6929C12.0941 16.3521 11.9417 18.0667 11.9417 19.6489H10.2678C10.1918 18.6854 10.0403 16.6511 10.0403 16.2251C10.0399 15.7992 9.53307 15.2365 9.27954 15.0083C6.92147 13.5377 2.26601 9.94246 2.50903 7.32568C2.81331 4.05468 5.24788 1.61985 10.0403 0.32666ZM12.6936 9.60791C15.8885 1.31632 17.6046 1.77265 17.4954 2.98975C17.0693 7.7364 14.2748 12.5743 12.9309 14.3999C10.7471 17.3665 12.0194 11.3579 12.6936 9.60791Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DriverIcon;
